import useProject from '@hooks/useProject';
import { useTranslation } from 'react-i18next';

/** /project 응답이 없을 때 */
const DEFAULT_DAILY_MAX_MAN = 20;
const DEFAULT_CARD_MAX_WON = 500_000;
const MAN_WON = 10_000;

type LimitError = 'daily' | 'balance';

/** /project 한도. perDayRechargeLimit, perCardRechargeLimit 은 원. */
function usePrepaidRechargeLimits() {
    const { t } = useTranslation('prepaidCard');
    const project = useProject();
    const dailyMaxWon = project?.perDayRechargeLimit ?? DEFAULT_DAILY_MAX_MAN * MAN_WON;
    const maxBalanceWon = project?.perCardRechargeLimit ?? DEFAULT_CARD_MAX_WON;
    const textParams = {
        max: dailyMaxWon / MAN_WON,
        maxWon: dailyMaxWon.toLocaleString(),
        balanceMax: maxBalanceWon / MAN_WON,
        balanceMaxWon: maxBalanceWon.toLocaleString(),
    };

    const getLimitError = (amountMan: number, currentBalanceWon = 0): LimitError | undefined => {
        if (amountMan <= 0) return undefined;
        if (amountMan * MAN_WON > dailyMaxWon) return 'daily';
        if (currentBalanceWon + amountMan * MAN_WON > maxBalanceWon) return 'balance';
        return undefined;
    };

    const getErrorText = (amountMan: number, currentBalanceWon = 0) => {
        const error = getLimitError(amountMan, currentBalanceWon);
        if (error === 'daily') return t('charge.errorDaily', textParams);
        if (error === 'balance') return t('charge.errorMaxBalance', textParams);
        return undefined;
    };

    return { textParams, getLimitError, getErrorText };
}

export default usePrepaidRechargeLimits;
